import { TFunction } from 'i18next';
import { Eye } from 'lucide-react';

import { ConsignmentLineTotals } from '@/entities/consignments';
import { DataTableColumn, TableAction } from '@/shared/ui/data-table';

import { ConsignmentLineRow } from '../model/types';

export const getConsignmentLineColumns = (
  t: TFunction,
  totals?: ConsignmentLineTotals
): DataTableColumn<ConsignmentLineRow>[] => [
  {
    id: 'category',
    accessorKey: 'category',
    header: t('product.description.label'),
    width: 'min-w-[150px]',
    cell: ({ index, description, category }) => [index, description, category].filter(Boolean).join(' - ') || '-'
  },
  {
    id: 'ownerReference',
    accessorKey: 'ownerReference',
    header: t('requestline.ownerItemIdentifier.label'),
    width: 'min-w-[150px]',
    cell: (row) => row.ownerReference || '-'
  },
  {
    id: 'inventoryUnits',
    accessorKey: 'inventoryUnits',
    header: t('requestline.ltuQty.short'),
    width: 'min-w-[150px]',
    cell: (row) => row.inventoryUnits || '-'
  },
  {
    id: 'handlingUnits',
    accessorKey: 'handlingUnits',
    header: t('bundle.bundleQty.label'),
    width: 'min-w-[150px]',
    cell: (row) => row.handlingUnits || '-'
  },
  {
    id: 'reportingUnit',
    accessorKey: 'reportingUnit',
    header: t('reportingUnit.description.label'),
    width: 'min-w-[150px]',
    cell: (row) => row.reportingUnit || '-'
  },
  {
    id: 'weight',
    accessorKey: 'weight',
    header: () => (
      <span>
        {t('requestline.unitWeight.label')}
        <span className="text-xs text-muted-foreground ml-1">({totals?.totalWeight})</span>
      </span>
    ),
    width: 'min-w-[120px]',
    cell: (row) => row.weight || '-'
  },
  {
    id: 'volume',
    accessorKey: 'volume',
    header: () => (
      <span>
        {t('requestline.unitVolume.label')}
        <span className="text-xs text-muted-foreground ml-1">({totals?.totalVolume})</span>
      </span>
    ),
    width: 'min-w-[120px]',
    cell: (row) => row.volume || '-'
  }
];

export const getConsignmentLineActionColumn = (
  t: TFunction,
  onViewClick: (row: ConsignmentLineRow) => void
): TableAction<ConsignmentLineRow>[] => [
  {
    id: 'view',
    label: t('consignment.lines.view', 'View'),
    icon: Eye,
    onClick: onViewClick
  }
];
